import {Message} from 'element-ui'

const showMsg = (msg, msg1) => {
  if (msg1) {
    setTimeout(() => {
      Message.error(msg1)
    }, 100)
  } else {
    setTimeout(() => {
      Message.error(msg)
    }, 100)
  }
}

/**
 * 数组校验
 * @param value 校验对象
 * @param element 数组
 */
const listCheck = (value, element) => {
  let flag = true

  if (!value instanceof Array) {
    flag = false
    showMsg('数据类型异常')
    return flag
  }

  if (element.required) {
    if (value.length === 0) {
      flag = false
      showMsg(element.prop + '不能为空', element.msg)
      return flag
    }
  }

  if (element.maxSize) {
    if (element.maxSize < value.length) {
      flag = false
      showMsg(element.prop + '数据量不能高于' + element.maxSize + '条', element.msg)
      return flag
    }
  }

  if (element.minSize) {
    if (element.minSize > value.length) {
      flag = false
      showMsg(element.prop + '数据量不能低于' + element.maxSize + '条', element.msg)
      return flag
    }
  }

  if (element.rules) {
    for (let i = 0; i < value.length; i++) {
      flag = check(value[i], element.rules) && flag
    }
  }

  return flag
}

/**
 * 文本校验
 * @param value 校验对象
 * @param element 数组
 */
const textCheck = (value, element) => {
  let flag = true

  // 校验最大长度
  if (element.maxlength) {
    if (value) {
      if (value.length > element.maxlength) {
        flag = false
        showMsg(element.prop + '字段长度不能超过' + element.maxlength + '个字符', element.msg)
        return flag
      }
    }
  }

  // 校验最小长度
  if (element.minlength) {
    if (!value) {
      flag = false
      return flag
    }
    if (value.length < element.minlength) {
      flag = false
      showMsg(element.prop + '字段长度不能低于' + element.minlength + '个字符', element.msg)
    }
  }

  return flag
}

/**
 * 文本校验
 * @param value 校验对象
 * @param element 数组
 */
const numberCheck = (value, element) => {
  let flag = true

  // 校验最大值
  if (element.max) {
    if (value) {
      if (Number(value) > Number(element.max)) {
        showMsg(element.prop + '最大值不能超过' + element.max, element.msg)
        flag = false
        return flag
      }
    }
  }

  // 校验最小值
  if (element.min) {
    if (value) {
      if (Number(value) < Number(element.min)) {
        showMsg(element.prop + '最小值不能超过' + element.min, element.msg)
        flag = false
      }
    }
  }
  return flag
}

/**
 * 手机号码校验
 * @param value 校验对象
 * @param element 数组
 */
const phoneCheck = (value, element) => {
  let flag = true

  if (value) {
    let reg = /^[1][3,4,5,7,8][0-9]{9}$/
    if (!reg.test(value)) {
      showMsg(element.prop + '格式错误', element.msg)
      return false
    }
  }

  return flag
}

/**
 * 遍历数据执行校验
 */
const check = (formData, rules) => {
  let flag = true
  for (let key in formData) {
    let rule = rules[key]
    let value = formData[key]
    if (rule) {
      for (let i = 0; i < rule.length; i++) {
        let element = rule[i]

        // 必填校验
        if (element.required) {
          if (value === null || value === undefined || value === '') {
            flag = false
            showMsg(element.prop + '不能为空', element.msg)
            continue
          }
        }

        if (element.type === 'string') {
          flag = textCheck(value, element) && flag
        } else if (element.type === 'number') {
          flag = numberCheck(value, element) && flag
        } else if (element.type === 'list') {
          flag = listCheck(value, element) && flag
        } else if (element.type === 'phone') {
          flag = phoneCheck(value, element) && flag
        }
      }
    }
  }

  return flag
}

/**
 * 数据校验
 * @param formData 表单数据
 * @param rules 校验规则
 * @returns {Promise<unknown>} 回调
 */
const validate = (formData, rules) => {
  console.log('校验', formData, rules)
  return new Promise((resolve, reject) => {
    let flag = check(formData, rules)
    if (flag) {
      resolve()
    } else {
      reject()
    }
  })
}

export {validate}
